<div class="faqWrapper" [@leave] [@enter]>
    <app-banner></app-banner> 
    <app-questions></app-questions>
</div>
